import { render, staticRenderFns } from "./VoteComment.vue?vue&type=template&id=6ef5977b&scoped=true&"
import script from "./VoteComment.vue?vue&type=script&lang=ts&"
export * from "./VoteComment.vue?vue&type=script&lang=ts&"
import style0 from "./VoteComment.vue?vue&type=style&index=0&id=6ef5977b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5977b",
  null
  
)

export default component.exports